function initCheckboxes() {
  const $checkbox = $('input[type=checkbox]');

  if ($checkbox.length > 0) {
    const $checkboxes = $('input[type=checkbox]');
    $checkboxes.each(function each() {
      const $cb = $(this);

      const id = $cb.attr('id');

      if (id.indexOf('{{') === -1) {
        let $label = $(`label[for=${$cb.attr('id')}]`);

        if ($label.length && $label.children('span').length === 0) {
          $label.prepend('<span></span>').addClass('checkLbl');

          $cb.change(() => {
            $label.toggleClass('checked');
          });

          if ($cb.is(':checked')) {
            $label.addClass('checked');
          }
        }

        // for the contact form where html is different to above
        if ($label.length === 0) {
          $label = $(`#${$cb.attr('id').replace('list_0', 'lb')}`);

          if ($label.length && $label.children('span').length === 0) {
            $label.prepend('<span></span>').addClass('checkLbl');

            $label.children('span').click(() => {
              $label.toggleClass('checked');
              $cb.prop('checked', !$cb.prop('checked'));
            });

            if ($cb.is(':checked')) {
              $label.addClass('checked');
            }
          }
        }
      }
    });
  }
}

initCheckboxes();

if (window.Sys) {
  Sys.WebForms.PageRequestManager.getInstance().add_endRequest(initCheckboxes);
}
